const STEPS = ["Measure", "Check size chart", "Order", "Wrong fit", "Return"];

const Problem = () => (
  <section id="problem" data-testid="problem-section" className="section-pad border-t border-[var(--line)]">
    <div className="container-x grid gap-14 lg:grid-cols-[1.1fr_1fr] lg:gap-20">
      <div>
        <p className="eyebrow mb-6">The Problem</p>
        <h2 className="font-display text-4xl leading-[1.1] tracking-tight sm:text-5xl">
          Your shoe size isn't always your fit.
        </h2>
        <p className="mt-6 max-w-md text-base leading-relaxed text-[var(--ink-soft)]">
          Sizing can vary between brands — and even between different models
          from the same brand. Measurements and size charts help, but they
          don't always tell you how a particular shoe will actually fit.
        </p>
      </div>

      <div className="flex flex-col justify-center gap-10">
        <ol data-testid="problem-flow" className="flex flex-wrap items-center gap-y-3">
          {STEPS.map((step, i) => (
            <li key={step} className="flex items-center">
              <span
                className={`rounded-md border px-3.5 py-2 text-xs tracking-wide ${
                  step === "Wrong fit"
                    ? "border-[var(--rust)] text-[var(--rust)]"
                    : "border-[var(--line)] text-[var(--ink-soft)]"
                }`}
              >
                <span className="mr-2 text-[0.6rem] uppercase opacity-60">{`0${i + 1}`}</span>
                {step}
              </span>
              {i < STEPS.length - 1 && (
                <span aria-hidden="true" className="mx-2 text-[var(--line)]">
                  →
                </span>
              )}
            </li>
          ))}
        </ol>
        <p className="font-display max-w-md text-2xl leading-snug tracking-tight md:text-[1.7rem]">
          What if we could learn from what actually fits people like you?
        </p>
      </div>
    </div>

    <div className="container-x mt-24 border-t border-[var(--line)] pt-16 md:mt-32">
      <blockquote data-testid="problem-statement" className="max-w-3xl">
        <p className="font-display text-3xl leading-[1.2] tracking-tight md:text-5xl">
          A measured foot can tell you its length.
          <span className="text-[var(--rust)]"> It can't tell you how every shoe will fit.</span>
        </p>
        <footer className="mt-6 text-base text-[var(--ink-soft)]">
          That's where real-world fit experience becomes valuable.
        </footer>
      </blockquote>
    </div>
  </section>
);

export default Problem;
